import { useCallback } from 'react';

import { pickUploadFiles } from '../utils/pickUploadFiles';
import { useDropFilesToCanvas } from './useDropFilesToCanvas';

/**
 * Opens a native file picker and uploads selected images or videos to the canvas.
 *
 * Delegates the actual upload + node creation to {@link useDropFilesToCanvas}.
 */
export const useUploadMediaToCanvas = () => {
  const { dropFilesToCanvas } = useDropFilesToCanvas();

  const handleUploadMedia = useCallback(
    (anchorPosition?: { x: number; y: number }) => {
      pickUploadFiles((files) => {
        void dropFilesToCanvas(files, anchorPosition);
      });
    },
    [dropFilesToCanvas],
  );

  return { handleUploadMedia };
};
